import {PayoutMethod} from '../../features/payout-report/constants';

export const PayoutMethodMapping = (payoutMethod: string) => {
    switch (payoutMethod.toUpperCase()) {
        case PayoutMethod.PAYPAL:
            return 'Paypal';
        case PayoutMethod.JPMORGAN:
            return 'Direct Deposit (ACH)';
        case PayoutMethod.PAYONEER:
            return 'Payoneer';
        case PayoutMethod.TIPALTI:
            return 'Tipalti';
        case PayoutMethod.WIRE:
            return 'Wire';
        case PayoutMethod.CHEQUE:
            return 'Cheque';
    }
    return '';
};
